import type { FC } from 'react'

import SignUpView from 'views/GrowthMasters/SignUpPage'

import RedirectToHome from 'views/GrowthMasters/components/RedirectToHome'

import useInitialCookie from 'views/GrowthMasters/hooks/useInitialCookie'

const SignUp: FC = () => {
  const [show, isLoading] = useInitialCookie()

  return show ? <RedirectToHome /> : isLoading ? null : <SignUpView />
}

export default SignUp
